import { useCopyToClipboard } from 'Modules/softphone/components/SoftphoneDevTools/hooks';
import { Check, Copy } from 'lucide-react';
import type { DevToolsCopyBoxProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsCopyBox/index.types';
import {
  MICRO_LABEL,
  SURFACE,
} from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * DevToolsCopyBox - A labelled identifier you can take away with one click
 */
export const DevToolsCopyBox: React.FC<DevToolsCopyBoxProps> = ({
  value,
  label,
  className,
}) => {
  const { copied, copy } = useCopyToClipboard();

  return (
    <div
      className={cn(
        'flex items-center gap-2 px-[9px] py-[7px]',
        SURFACE.inset,
        className
      )}
    >
      {label && <span className={MICRO_LABEL}>{label}</span>}
      <span
        className="min-w-0 flex-1 truncate font-sp-mono text-[11px] text-zinc-200"
        title={value}
      >
        {value}
      </span>
      <button
        type="button"
        onClick={() => copy(value)}
        aria-label={label ? `Copy ${label}` : 'Copy'}
        className="flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-[5px] border border-zinc-800 text-zinc-400 transition-colors hover:border-emerald-800 hover:text-emerald-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/40"
      >
        {copied ? (
          <Check className="h-2.5 w-2.5 text-emerald-400" />
        ) : (
          <Copy className="h-2.5 w-2.5" />
        )}
      </button>
    </div>
  );
};
